//全てのfunctionをここでimportしてexportする
import $ from "jquery";
// import { Application } from "@hotwired/stimulus";
// import { ToastController } from "./ToastController.js";
// import { ModalController } from "./ModalController.js";
// import { NewsletterController } from "./NewsletterController.js";
// import { DatePickerController } from "./DatePickerController.js";
// import { EditNewsListController } from "./EditNewsListController.js";

export { HtmlFix, HtmlScroll };
export { PasswordVisibility } from "./passwordVisibility.js";
export { DatePicker } from "./datePicker.js";
export { ToastMessage } from "./toast.js";
export { Toggle } from "./toggle.js";
export { HandleSearchRadioSet } from "./handleSearchRadioSet.js";
export { BannerMediumSlider } from "./bannerMediumSlider.js";
export { BannerSmallSlider } from "./bannerSmallSlider.js";
export { Modal } from "./modal.js";
export { HeaderMenu } from "./header.js";
export { SmoothScroll } from "./smoothScroll.js";
export { EventDetailSlider } from "./eventDetailSlider.js";
export { EventDetailModalSlider } from "./eventDetailModalSlider.js";
export { EventDetailNav } from "./eventDetailNav.js";
export { ToggleMore } from "./toggleMore.js";
export { TicketSelectSubmit } from "./ticketSelectSubmit.js";
export { RadioToggle } from "./radioToggle.js";
export { GetFinishedEvent } from "./getFinishedEvent.js";
export { TopEventSlider } from "./topEventSlider.js";
export { ResidenceSelect } from "./residenceSelect.js";
export { TextCopy } from "./textCopy.js";
export { EditNewsList } from "./editNewsList.js";
export { ToggleAllSwitches } from "./toggleAllSwitches.js";

// Stimulus を初期化してコントローラーを登録する
// const app = Application.start();
// app.register("toast", ToastController);
// app.register("modal", ModalController);
// app.register("newsletter", NewsletterController);
// app.register("date-picker", DatePickerController);
// app.register("edit-news-list", EditNewsListController);
// app.register("handle-search-radio-set", HandleSearchRadioSetController);

// $(function () {
//   ariaDisabled();
// });

// ====================
// 汎用function
// ====================
//スクロール禁止状態にする
function HtmlFix() {
  var st = $(window).scrollTop() * -1;
  $("html").addClass("is-fixed");
  $("body").css("top", st);
}

//スクロール禁止状態を解除する
function HtmlScroll() {
  var st = parseFloat($("body").css("top")) * -1;
  $("html").removeClass("is-fixed").scrollTop(st);
  $("body").removeAttr("style");
}

//==========
// aria-disabled アクセシビリティ対応
//==========
// function ariaDisabled() {
//   const DIS = "[aria-disabled='true']";
//   $(document).on("click", DIS, function (e) {
//     e.preventDefault();
//     e.stopPropagation();
//     return;
//   });
// }
